module.exports = __webpack_public_path__ + "img/coupon-popup-item-use-hen.35e00914.png";